import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from "react";
import { DashboardContextProvider, useAuthContext, CONFIG_KEYS } from ".";
const InsightsDashboard = lazy(() => import("./InsightsDashboard.jsx"));
const Insights = lazy(() => import("pages/Insights"));
const DashboardController = () => {
    const { globalConfigMap } = useAuthContext();
    const newDashboardEnabled = globalConfigMap.isEnabled(CONFIG_KEYS.newDashboardEnabled, true);
    console.log(`[INFO] New dashboard enabled: ${newDashboardEnabled}`);
    return (_jsx(DashboardContextProvider, { children: _jsx(InsightsDashboard, {}) }));
};
export default DashboardController;
